/**

 * Web-only mitigation: hides sensitive subtree when the window loses focus or

 * the document is not visible (e.g. tab switch). Does not prevent OS-level

 * capture; there is no reliable browser API to block screenshots/recordings.

 *

 * Future native apps (TODO — not implemented here):

 * - Android: use WindowManager.LayoutParams.FLAG_SECURE on the sensitive

 *   Activity/Fragment window to discourage screenshots and screen recording.

 * - iOS: detect UIScreen.isCaptured / screen mirroring notifications and

 *   overlay or pause sensitive UI when recording/mirroring is active.

 */



import React, { useCallback, useEffect, useRef, useState } from "react";



import "./SensitiveContentGuard.css";



export default function SensitiveContentGuard({

  children,

  className = "",

  maskOnBlur = true,

}) {

  const windowBlurredRef = useRef(false);

  const maskOnBlurRef = useRef(maskOnBlur);

  const [masked, setMasked] = useState(false);



  maskOnBlurRef.current = maskOnBlur;



  const applyMask = useCallback(() => {

    if (typeof document === "undefined") return;



    const hidden = document.visibilityState === "hidden";

    if (hidden) {

      console.log("[SensitiveContentGuard] mask visibility hidden");

      setMasked(true);

      return;

    }



    if (windowBlurredRef.current && maskOnBlurRef.current) {

      setMasked(true);

      return;

    }



    setMasked(false);

  }, []);



  useEffect(() => {

    const onBlur = () => {

      windowBlurredRef.current = true;

      if (maskOnBlurRef.current) {

        applyMask();

      } else {

        console.log("[SensitiveContentGuard] mask blur ignored maskOnBlur=false");

      }

    };



    const onFocus = () => {

      windowBlurredRef.current = false;

      applyMask();

    };



    const onVisibilityChange = () => {

      if (document.visibilityState === "hidden") {

        applyMask();

      } else {

        console.log("[SensitiveContentGuard] unmask visibility visible");

        applyMask();

      }

    };



    window.addEventListener("blur", onBlur);

    window.addEventListener("focus", onFocus);

    document.addEventListener("visibilitychange", onVisibilityChange);



    applyMask();



    return () => {

      window.removeEventListener("blur", onBlur);

      window.removeEventListener("focus", onFocus);

      document.removeEventListener("visibilitychange", onVisibilityChange);

    };

  }, [applyMask]);



  const rootClass = ["sensitive-guard", className].filter(Boolean).join(" ");



  return (

    <div className={rootClass}>

      {children}

      {masked ? (

        <div

          className="sensitive-guard__overlay"

          role="status"

          aria-live="polite"

        >

          <span className="sensitive-guard__message">

            تم إخفاء المحتوى لحماية الخصوصية

          </span>

        </div>

      ) : null}

    </div>

  );

}


